module.exports = __webpack_public_path__ + "img/bottom.b9ebbf90.png";